module.exports = __webpack_public_path__ + "static/img/share-tip-txt.a44cc319.png";